import React from 'react'

import { buttonLabel } from './styles'
import { cssClass } from '@/shared/utils/styles'

interface Props {
  label?: string
  className?: string[]
}

export const LabelButton = ({ label, className = [] }: Props) => {
  return <span className={cssClass([buttonLabel, ...className])}>{label}</span>
}
